import React, { useContext, useMemo } from 'react';

type FetchQueryErrorProviderProps = {
  children?: React.ReactNode;
  error?: Error;
};

const FetchQueryErrorContext = React.createContext<{
  error?: Error;
}>({
  error: undefined,
});

export const FetchQueryErrorProvider = ({
  children,
  error,
}: FetchQueryErrorProviderProps) => {
  const contextValue = useMemo(
    () => ({
      error,
    }),
    [error]
  );
  return (
    <FetchQueryErrorContext.Provider value={contextValue}>
      {children}
    </FetchQueryErrorContext.Provider>
  );
};

export function useFetchQueryError() {
  return useContext(FetchQueryErrorContext);
}
